import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface TimeOutState {
  isTimeoutVisible: boolean;
}
const initialState: TimeOutState = {
  isTimeoutVisible: false,
};

export const timeoutSlice = createSlice({
  name: "timeOut",
  initialState,
  reducers: {
    TimeOutSet: (state, action: PayloadAction<boolean>) => {
      state.isTimeoutVisible = action.payload;
    },
    resetTimeOut: () => initialState,
  },
});

export const { TimeOutSet, resetTimeOut } = timeoutSlice.actions;

export const selectTimeOut = (state: RootState) =>
  state.timeOut.isTimeoutVisible;

export default timeoutSlice.reducer;
